<template lang='pug'>
  v-card-text
    v-timeline(align-top dense)
      v-timeline-item(color="accent" small)
        v-row(v-if="showCameraNavigateMode" class="pt-1")
          v-col
            span.subtitle-1 Touch tapping
            ul
              li Touch mode may require triple tapping as double tap isn't detected reliably yet
        v-row(class="pt-1")
          v-col
            span.subtitle-1 {{ showCameraNavigateMode ? 'Camera navigation' : 'View navigation' }}
            div(v-if="showCameraNavigateMode")
              ul.icon-list
                li Double tap to reframe the character or body section
                li
                  v-btn.mx-4(outlined fab small color='accent')
                    v-icon $panCamera
                  | moves the scene in the direction of drag.
                li
                  v-btn.mx-4(outlined fab small color='accent')
                    v-icon $fpsCamera
                  | moves the camera like FPS mode. Dragging up moves forward.
                li
                  v-btn.mx-4(outlined fab small color='accent')
                    v-icon $rotateCamera
                  | rotates the camera around a focal point.
                li
                  v-btn.mx-4(outlined fab small color='accent')
                    v-icon $zoomCamera
                  | zooms the camera in and out.
                li
                  v-btn.mx-4(outlined fab small color='accent')
                    v-icon $exitCamera
                  | exits camera nagivation to normal operation.
            ul(v-else)
              li Rotate with alt+drag
              li Pan with middle mouse+drag
              li Zoom with middle mouse scroll
              li First person navigation with WASD+QE keys
              li F key reframes the character or body section
        v-row(class="pt-1")
          v-col
            span.subtitle-1 Modeling section tuning
            ul
              li Double click on the head, neck, body, legs, or feet to tune the section
              li U key while tuning a body section backs up to character level
        v-row(class="pt-1")
          v-col
            span.subtitle-1 Pose section tuning
            ul
              li Double click in an empty area to hide secondary controls
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon {{mdiEyeOutline}}
            | previews the asset file
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon share
            | copies a link for sharing
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon {{mdiRestore}}
            | resets the character build or pose
</template>

<script>
import { mdiRestore, mdiEyeOutline } from '@mdi/js'

export default {
  name: 'Day6InfoEditorTips',
  props: {
    showCameraNavigateMode: Boolean
  },
  data: () => ({
    mdiRestore,
    mdiEyeOutline
  })
}
</script>

<style lang="scss" scoped>
ul.icon-list {
  list-style: none;
  padding: 0;

  > li {
    padding: 4px 0;
  }
}
</style>
